import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

export function trackCianDobroBannerClick(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'cian_dobro_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'cian_dobro',
        bannerName: 'Баннер Циан.Добро',
        trapid: 'Баннер Циан.Добро',
        source,
      },
    },
    sc: jsonQuery,
  });
}

export function trackCianDobroBannerShow(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'cian_dobro_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'cian_dobro',
        bannerName: 'Баннер Циан.Добро',
        trapid: 'Баннер Циан.Добро',
        source,
      },
    },
    sc: jsonQuery,
  });
}
